module.exports = __webpack_public_path__ + "img/1eb2c64.jpg";